module.exports = __webpack_public_path__ + "img/9788991813939.255b8089.jpg";